import CoursesApi from '../api/courses';

export default {
  namespaced: true,
  state: {
    courses: [],
    selectedCourse: null,
  },
  getters: {
    allCourses(state) {
      return state.courses;
    },
    selectedCourse(state) {
      return state.selectedCourse;
    },
  },
  actions: {
    getCourses(context, includeDrafts = false) {
      return new Promise((resolve, reject) => {
        CoursesApi.getCourses(includeDrafts)
          .then((response) => {
            context.commit('SET_COURSES', response.result);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSelectedCourse(context, courseSlug) {
      return new Promise((resolve, reject) => {
        CoursesApi.getCourse(courseSlug)
          .then((response) => {
            context.commit('SET_SELECTED_COURSE', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateCourse(context, course) {
      console.log('saving course');
      return new Promise((resolve, reject) => {
        CoursesApi.updateCourse(course)
          .then((response) => {
            console.log('course saved');
            context.commit('SET_SELECTED_COURSE', response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    addMemberToCourse(context, { courseId, userId }) {
      console.log('adding user to course', courseId, userId);
      return new Promise((resolve, reject) => {
        CoursesApi.addMemberToCourse(courseId, userId)
          .then((response) => {
            console.log('course saved');
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    createCourse(context, course) {
      console.log('creating course');
      return new Promise((resolve, reject) => {
        CoursesApi.createCourse(course)
          .then((response) => {
            console.log('course created');
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    deleteCourse(context, course) {
      return new Promise((resolve, reject) => {
        CoursesApi.deleteCourse(course)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_COURSES: (state, courses) => {
      state.courses = courses;
    },
    SET_SELECTED_COURSE: (state, course) => {
      state.selectedCourse = course;
    },
  },
};
